"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var io = require("socket.io-client");
var client = null;
var configuration = {
    serverUrl: '',
};
var currentSubscriptions = {};
/**
 * Sets the global configuration for the Results Hub connection
 * @param serverUrl URL of server to connect to
 * @throws {Error} Illegal Operation if configuration is attempted while connect exists
 */
function configure(serverUrl) {
    if (client != null) {
        throw new Error('Illegal Operation');
    }
    configuration.serverUrl = serverUrl;
    return __assign({}, configuration);
}
exports.configure = configure;
/**
 * Initializes the global Results Hub connection, if necessary
 */
function initialize() {
    return new Promise(function (resolve) {
        if (client === null) {
            if (!configuration.serverUrl) {
                throw new Error('Missing Server URL');
            }
            client = io(configuration.serverUrl);
            client.on('connect', function () {
                // On reconnect, restore expected/existing subscriptions
                // `on` handler already established.
                Object.keys(currentSubscriptions).forEach(function (x) {
                    var subs = currentSubscriptions[x];
                    subs.forEach(function (sub) {
                        client.emit('subscribe', sub);
                    });
                });
                resolve();
            });
        }
        else {
            resolve();
        }
    });
}
function maybeSubscription(url, callback) {
    if (url === void 0) { url = ''; }
    return (currentSubscriptions[url] || [])
        .filter(function (x) { return x.callback === callback; })
        .map(function (x) { return (__assign({}, x)); })
        .find(function (x) { return !!x; });
}
exports.maybeSubscription = maybeSubscription;
/**
 * Creates/Joins a topic for the requested URL
 *
 * @param url URL being requested
 * @param callback Function executed on topic update
 * @param interval Requested interval to poll at. If an existing topic exists, the current
 * interval will be used
 */
function subscribe(url, callback, interval) {
    if (url === void 0) { url = ''; }
    if (interval === void 0) { interval = 30000; }
    return __awaiter(this, void 0, void 0, function () {
        var e_1, existingTopic, subMsg, sub;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, initialize()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3:
                    existingTopic = maybeSubscription(url, callback);
                    client.on(url, callback);
                    if (!existingTopic) {
                        subMsg = { interval: interval, url: url };
                        sub = __assign({ callback: callback }, subMsg);
                        currentSubscriptions[url] = (currentSubscriptions[url] || []).concat(sub);
                        if (!existingTopic) {
                            client.emit('subscribe', subMsg);
                        }
                        existingTopic = __assign({}, sub);
                    }
                    return [2 /*return*/, existingTopic];
            }
        });
    });
}
exports.subscribe = subscribe;
/**
 * Unsubscribes from a topic with a specific callback
 * @param url URL used during subscription
 * @param callback Callback specified during subscription
 */
function unsubscribe(url, callback) {
    if (url === void 0) { url = ''; }
    if (client !== null) {
        if (url in currentSubscriptions) {
            var sub = currentSubscriptions[url].find(function (x) { return x.callback === callback; });
            if (sub) {
                var subMsg = { interval: 0, url: url };
                client.removeListener(url, sub.callback);
                if (currentSubscriptions[url].length > 1) {
                    currentSubscriptions[url] = currentSubscriptions[url]
                        .filter(function (x) { return x.callback !== callback; });
                }
                else {
                    client.emit('unsubscribe', subMsg);
                    delete currentSubscriptions[url];
                    if (Object.keys(currentSubscriptions).length === 0) {
                        dispose();
                    }
                }
                return true;
            }
        }
    }
    return false;
}
exports.unsubscribe = unsubscribe;
/**
 * Unsubscribes all callbacks for a given URL
 * @param url URL of subscription
 */
function unsubscribeUrl(url) {
    if (url === void 0) { url = ''; }
    return (currentSubscriptions[url] || [])
        .reduce(function (acc, cur) { return unsubscribe(url, cur.callback) ? acc + 1 : acc; }, 0);
}
exports.unsubscribeUrl = unsubscribeUrl;
/**
 * Unsubscribes all registered subscriptions
 */
function unsubscribeAll() {
    return Object.keys(currentSubscriptions)
        .reduce(function (acc, cur) { return acc + unsubscribeUrl(cur); }, 0);
}
exports.unsubscribeAll = unsubscribeAll;
/**
 * Kills everything here
 */
function dispose() {
    var unsubbed = unsubscribeAll();
    if (client) {
        client.disconnect();
    }
    client = null;
    return unsubbed;
}
exports.dispose = dispose;
//# sourceMappingURL=Client.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/results-hub-client/lib/Client.js
 ** module id = 3038
 ** module chunks = 0
 **/